// extracted by mini-css-extract-plugin
export var Section = "CorporateGovernance-module--Section--q+RSo";
export var LangHY = "CorporateGovernance-module--LangHY--f74f7";
export var Title = "CorporateGovernance-module--Title--nODd7";
export var Desc = "CorporateGovernance-module--Desc--YPMUt";
export var FileText = "CorporateGovernance-module--FileText--u30Qc";
export var FileSize = "CorporateGovernance-module--FileSize--YilK+";
export var Header = "CorporateGovernance-module--Header--lTZcd";
export var Inner = "CorporateGovernance-module--Inner--ARKrE";
export var Tabs = "CorporateGovernance-module--Tabs--aWR7H";
export var Tab = "CorporateGovernance-module--Tab--gbU4z";
export var Active = "CorporateGovernance-module--Active--OSsid";
export var Content = "CorporateGovernance-module--Content--JkBJ6";
export var File = "CorporateGovernance-module--File--ByDW0";
export var IconPdfWrap = "CorporateGovernance-module--IconPdfWrap--nWOXq";
export var FileContent = "CorporateGovernance-module--FileContent--q0ygL";
export var FileBtn = "CorporateGovernance-module--FileBtn--TtrCB";
export var arrowLeft = "CorporateGovernance-module--arrowLeft--6t2gO";
export var arrowRight = "CorporateGovernance-module--arrowRight--OBgh7";